var map = {
	"./back/Taster_cozy.svg": [
		188,
		188
	],
	"./back/Taster_juicy.svg": [
		4055,
		55
	],
	"./back/Taster_lightning.svg": [
		5341,
		341
	],
	"./back/Taster_random.svg": [
		9004,
		4
	],
	"./back/Taster_real.svg": [
		3973,
		973
	],
	"./linkicon.svg": [
		7106,
		106
	],
	"./pattern/Taster_cozy.svg": [
		781,
		781
	],
	"./pattern/Taster_juicy.svg": [
		6799,
		180
	],
	"./pattern/Taster_lightning.svg": [
		8442,
		442
	],
	"./pattern/Taster_random.svg": [
		9321,
		321
	],
	"./pattern/Taster_real.svg": [
		5312,
		312
	],
	"./patternFull/Taster_cozy.svg": [
		4942,
		942
	],
	"./patternFull/Taster_juicy.svg": [
		2481,
		481
	],
	"./patternFull/Taster_real.svg": [
		8607,
		607
	],
	"./skipicon.svg": [
		9795,
		795
	],
	"./title/Taster_cozy.svg": [
		7685,
		685
	],
	"./title/Taster_juicy.svg": [
		9575,
		956
	],
	"./title/Taster_real.svg": [
		8,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1995;
module.exports = webpackAsyncContext;